import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { assetKeys } from '@/services/db/asset/entity';
import { requireWorkspaceId } from '@/services/db/shared/workspace';

export function useRefetchAssets() {
  const queryClient = useQueryClient();
  const workspaceId = requireWorkspaceId();

  const refetch = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: assetKeys.lists(workspaceId),
    });
  }, [queryClient, workspaceId]);

  return refetch;
}
